import {Languages} from '../assets/constants/constants';
import {useEffect, useState} from 'react';
import i18next from 'i18next';

const useLanguage = () => {
  const getLanguage = (language: string) => {
    return Languages.find(option => option.value === language) || Languages[0];
  };
  const [language, setLanguage] = useState(getLanguage(i18next.language));

  const saveLocale = (locale: string) => {
    localStorage.setItem('locale', locale);
  };

  const handleLanguageChange = (language: string) => {
    const currentLanguage = getLanguage(language);
    setLanguage(currentLanguage);
    saveLocale(currentLanguage.locale);
  };

  useEffect(() => {
    i18next.on('languageChanged', handleLanguageChange);

    return () => {
      i18next.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return language;
};

export default useLanguage;
